import { render, staticRenderFns } from "./AppointmentDetailsView.vue?vue&type=template&id=15a70b2e&scoped=true"
import script from "./AppointmentDetailsView.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentDetailsView.vue?vue&type=style&index=0&id=15a70b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a70b2e",
  null
  
)

export default component.exports